import { render } from "./CasePage.vue?vue&type=template&id=0a7bbc80"
import script from "./CasePage.vue?vue&type=script&lang=js"
export * from "./CasePage.vue?vue&type=script&lang=js"

import "./CasePage.vue?vue&type=style&index=0&id=0a7bbc80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__